import ChartFactory from "blocks/reports/custom-report/chart-factory";
import Report from "blocks/reports/base/report";

export const Preview = ({
  filters = [],
  measures = [],
  timeDimensions = [],
  dimensions = [],
  order = [],
  limit = 12,
  compare = false,
  compareDateRange = "",
  dataType = "single",
  chartType = "LINE",
}) => {
  return (
    <Report
      measures={measures}
      timeDimensions={timeDimensions}
      //timeDimension={timeDimensions?.[0]}
      dimensions={dimensions}
      filters={filters}
      order={order}
      limit={limit}
      draggable={false}
      applyGlobalFilters={false}
      applyDateRangeFilter={compare ? true : false}
      compareDateRange={compareDateRange}
      compare={compare}
      dataType={
        timeDimensions?.length && timeDimensions[0]?.granularity
          ? "time_series"
          : "single"
      }
    >
      {(response) => {
        return (
          <ChartFactory
            chartType={chartType}
            {...response}
            hideLegend={true}
            compare={!!response.compareResultSet}
            dataType={dataType}
          />
        );
      }}
    </Report>
  );
};
